import styled from 'styled-components'
import * as Accordion from '@radix-ui/react-accordion'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'
import { DetailsCard } from '../DetailsCard/DetailsCard'
import { ShopTheLookButton } from '../ShopTheLookButton/ShopTheLookButton'
import { UnstyledList } from '../UnstyledList/UnstyledList'

export const GiftCardSectionWrapper = styled.div`
  margin: 0 auto;
  max-width: var(--container-max-width);
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Footer = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    margin: 1.5rem 0;
    display: block;
  }
`

export const InfoLinks = styled.div<{ length: number }>`
  display: flex;
  cursor: pointer;
  margin: 2rem 0;
  ${({ length }) =>
    length <= 2 ? 'gap: 1rem;' : 'justify-content: space-between;'}
`

export const Hr = styled.hr`
  width: 100%;
  height: 0;
  border-top-color: ${({ theme }) => theme.colors.border};
  margin: 0;
`

export const Separator = styled.div`
  width: 1px;
  margin: 0.2rem;
  background: ${({ theme }) => theme.colors.primary};
  transform: rotate(31deg);
`

export const MainContainer = styled.div`
  width: 100%;
  max-width: var(--container-max-width);
  margin: 0 auto;

  @media (min-width: 992px) {
    padding: 0 1.5rem;
  }
`

export const MainBlock = styled.div`
  @media (min-width: 992px) {
    display: flex;
    gap: 2rem;
  }

  @media screen and (min-width: 1200px) {
    margin-top: 1.2rem;
  }
`

export const GiftCardMessageWrapper = styled.div`
  padding: 0 1.5rem;
  margin-top: 0.5rem;
  @media (min-width: 768px) {
    padding: 0;
  }
`

export const ImageBlock = styled.div`
  @media (min-width: 992px) {
    margin-bottom: 3rem;
    flex: 64.7%;
  }
`

export const ProductSectionsContainer = styled.div`
  max-width: var(--container-max-width);
  margin: 3rem auto 1rem auto;
  padding: 0;

  @media (min-width: 992px) {
    padding: 0 1.5rem;
  }
`

export const ProductSections = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;

  &.product-section-desktop {
    .tablist-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      justify-content: space-between;
      align-items: center;
      background-color: ${({ theme }) => theme.colors.boxBackground};
      padding: 0rem 2rem;
      min-height: 60vh;
      width: 100%;
    }

    .tablist-content {
      width: 85%;
    }
  }
`

export const ProductInfoBlock = styled.div<{
  hasCollectionBrandName: boolean
  headerHeight: number
}>`
  display: flex;
  flex-direction: column;

  @media (min-width: 992px) {
    align-self: flex-start;
    flex: 35.3%;
    max-width: 45rem;
    margin-top: -2rem;
    padding: 2rem 0;
  }
`

export const GuaranteeIcons = styled.div`
  padding: 0 2rem;
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;

  svg {
    width: 10rem;
    stroke-opacity: 0;

    path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`

export const Sliders = styled.div`
  div:last-child {
    .product-slider {
      margin-bottom: 0;
    }
  }
`

export const StyledDetailsCard = styled(DetailsCard)`
  width: 100%;

  @media screen and (min-width: 768px) {
    width: 100%;
    margin-right: 1rem;
  }
`

export const StyledShopTheLookButton = styled(ShopTheLookButton)`
  position: absolute;
  z-index: 2;
  bottom: 1.6rem;
  left: 3rem;

  @media screen and (min-width: 992px) {
    top: 3rem;
    left: 3rem;
    bottom: auto;
  }
`

export const MobileAccordionRoot = styled(UnstyledList)`
  width: 100vw;
`

export const MobileAccordionItem = styled.li`
  margin: 1rem 0 1rem 0;
`

export const MobileAccordionTrigger = styled(Accordion.Trigger)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 2rem;
  border: none;
  background-color: ${({ theme }) => theme.colors.boxBackground};
`

export const MobileAccordionChevron = styled(ArrowDownIcon)<{
  $animationTiming: number
}>`
  color: currentColor;
  width: 1.2rem;
  margin-left: 1rem;
  transform-origin: 50% 50%;
  transition: transform ${(props) => props.$animationTiming}ms;

  [data-state='open'] & {
    transform: rotate(180deg);
  }
`

export const MobileAccordionContent = styled(Accordion.Content)<{
  $animationTiming: number
}>`
  overflow: hidden;

  &[data-state='open'] {
    animation: slideDown ${(props) => props.$animationTiming}ms ease-out;
  }

  &[data-state='closed'] {
    animation: slideUp ${(props) => props.$animationTiming}ms ease-out;
  }

  @keyframes slideDown {
    from {
      height: 0;
    }
    to {
      height: var(--radix-accordion-content-height);
    }
  }

  @keyframes slideUp {
    from {
      height: var(--radix-accordion-content-height);
    }
    to {
      height: 0;
    }
  }
`
